var fails = require('../internals/fails');

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/correct-prototype-getter.js
// module id = 447
// module chunks = 0